module.exports = __webpack_public_path__ + "img/tappy-big-blue.6fa9bc6f.svg";